import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { getHomeTokens } from '../getHomeTokens';
import { HOME_LAYOUT_SIZES } from '../homeTokens';

export interface HubCardCtaProps {
  label: string;
}

export function HubCardCta({ label }: HubCardCtaProps): JSX.Element {
  const theme = useTheme();
  const homeTokens = getHomeTokens(theme);

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: HOME_LAYOUT_SIZES.ctaHeight,
        px: 2.5,
        borderRadius: `${HOME_LAYOUT_SIZES.ctaRadius}px`,
        backgroundColor: homeTokens.hubCtaBackground,
        color: homeTokens.hubCtaColor,
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: '20px',
        letterSpacing: '-0.1504px',
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </Box>
  );
}
